import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { bpmnPageBpmnNotice, bpmnNoticeVisitUrl, setUserRead, setUserAllRead } from "@/api/bpmnApi/bpmn";
import { remote } from "@/api/admin/dict";
import { mapActions } from "vuex";
export default {
  name: "Message",
  components: {
    Sift: Sift
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [],
      paramSearch: {
        current: 1,
        size: 6,
        messageType: ""
      },
      messageTypeList: [],
      list: [],
      total: 0
    };
  },
  computed: {
    msglist: function msglist() {
      var arr = [];
      var year = [];
      var yearMonth = [];
      this.list.forEach(function (item, index) {
        var splitArr = item.createTime.split("-");
        var itemYear = splitArr[0];
        var itemYearMonth = splitArr[0] + "-" + splitArr[1];
        var itemYearStr = "";
        var itemYearMonthstr = "";

        if (!year.includes(itemYear)) {
          itemYearStr = itemYear;
          year.push(itemYear);

          if (!yearMonth.includes(itemYearMonth)) {
            itemYearMonthstr = itemYearMonth;
            yearMonth.push(itemYearMonth);
            arr.push(_objectSpread(_objectSpread({}, item), {}, {
              year: itemYearStr,
              yearMonth: itemYearMonthstr
            }));
          } else {
            arr.push(_objectSpread(_objectSpread({}, item), {}, {
              year: itemYearStr,
              yearMonth: itemYearMonthstr
            }));
          }
        } else {
          if (!yearMonth.includes(itemYearMonth)) {
            itemYearMonthstr = itemYearMonth;
            yearMonth.push(itemYearMonth);
            arr.push(_objectSpread(_objectSpread({}, item), {}, {
              year: itemYearStr,
              yearMonth: itemYearMonthstr
            }));
          } else {
            arr.push(_objectSpread(_objectSpread({}, item), {}, {
              year: itemYearStr,
              yearMonth: itemYearMonthstr
            }));
          }
        }
      });
      return arr;
    },
    setMsgName: function setMsgName() {
      return function (val) {
        var name = "";
        this.messageTypeList.forEach(function (o) {
          if (o.value == val) {
            name = o.label;
          }
        });
        return name;
      };
    },
    getStatus: function getStatus() {
      var blo = this.list.findIndex(function (item) {
        return item.readFlag == "0";
      }) > -1 ? true : false;
      return blo;
    }
  },
  created: function created() {
    this.remoteFn();
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions(["GetUnreadCount"])), {}, {
    clickMore: function clickMore() {
      this.paramSearch.current++;
      this.getBpmnPageBpmnNotice();
    },
    initList: function initList() {
      this.paramSearch.current = 1;
      this.list = [];
      this.getBpmnPageBpmnNotice();
    },
    seeDetailFn: function seeDetailFn(msg) {
      console.log(msg);

      if (msg.messageType == "90") {
        this.$router.push({
          path: "/mine/suggest"
        });
        return;
      }

      if (msg.messageType == "98") {
        this.$router.push({
          path: "/mine/voiceMessage"
        });
      }

      if (msg.msgType == "93" && msg.content.indexOf("http") > -1) {
        this.readClick(msg);
        window.open(msg.content);
      }

      if ((msg.msgType == "21" || msg.msgType == "23" || msg.msgType == "20") && msg.content.indexOf("http") > -1) {
        this.readClick(msg);
        window.open(msg.content);
      }
    },
    getBpmnNoticeVisitUrl: function getBpmnNoticeVisitUrl(msg) {
      var _this = this;

      var params = {
        taskId: msg.taskId,
        instId: msg.instId
      };
      bpmnNoticeVisitUrl(params).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.GetUnreadCount();

          window.open(data.data);
        } else {
          _this.$message.warning(data.msg);
        }
      }).catch(function (err) {});
    },
    getBpmnPageBpmnNotice: function getBpmnPageBpmnNotice() {
      var _this2 = this;

      this.loading = true;
      bpmnPageBpmnNotice(this.paramSearch).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          var Arr = (data.data.records || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              msgType: item.type
            });
          });
          _this2.list = [].concat(_toConsumableArray(_this2.list), _toConsumableArray(Arr));
          _this2.total = data.data.total;
        } else {
          _this2.$message.warning(data.msg || "获取消息失败");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    //获取类型
    remoteFn: function remoteFn() {
      var _this3 = this;

      remote("message_type").then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this3.messageTypeList = data.data || [];

          if (_this3.messageTypeList.length) {
            _this3.paramSearch.messageType = _this3.messageTypeList[0].value;
          }
        } else {
          _this3.$message.warning(data.msg || "获取类型失败!");
        }
      }).catch(function (err) {
        _this3.$message.error(data.msg || "获取类型异常!");
      });
    },
    notyDetailFn: function notyDetailFn(msg) {
      var routeData = this.$router.resolve({
        name: "/notifyDetail",
        query: {
          id: msg.id
        }
      });
      window.open(routeData.href);
    },
    formatText: function formatText(title, length) {
      var num = length || 10;
      var titleStr = title || "";

      if (titleStr.length > num) {
        titleStr = titleStr.substring(0, 10) + "...";
      }

      return titleStr;
    },
    // 单条标记已读
    readClick: function readClick(msg) {
      var _this4 = this;

      var params = {
        id: msg.id || "",
        type: msg.type || "",
        userId: this.$store.getters.userData.userId || ""
      };
      setUserRead(params).then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this4.$message.success("标记已读成功!");

          _this4.list = [];

          _this4.getBpmnPageBpmnNotice();
        } else {
          _this4.$message.warning(data.msg || "标记已读失败");
        }
      }).catch(function (err) {
        _this4.$message.error(data.msg || "标记已读异常!");
      });
    },
    //全部标记已读
    setAllread: function setAllread() {
      var _this5 = this;

      var params = {
        userId: this.$store.getters.userData.userId || ""
      };
      this.$confirm("确认全部标记为已读?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        setUserAllRead(params).then(function (_ref5) {
          var data = _ref5.data;

          if (data.code == 0) {
            _this5.$message.success("标记已读成功!");

            _this5.list = [];

            _this5.getBpmnPageBpmnNotice();
          } else {
            _this5.$message.warning(data.msg || "标记已读失败");
          }
        }).catch(function (err) {
          _this5.$message.error(data.msg || "标记已读异常!");
        });
      });
    }
  }),
  watch: {
    "paramSearch.messageType": function paramSearchMessageType() {
      this.initList(); // this.remoteFn()
    }
  },
  filters: {}
};